<aumico-users-edit-security-component
    (changeInPassword)="onPasswordChange($event)"
></aumico-users-edit-security-component>

<!-- REV-22124: after a password change in an org with 2FA the new login has not passed 2FA yet -->
<ham-modal
    *ngIf="reloginReason != null"
    data-testid="change-password-relogin-modal"
    [title]="
        (reloginReason === 'changed'
            ? localizationKeys.aumico_change_password_relogin_title
            : localizationKeys.aumico_change_password_relogin_failed_title
        ) | i18next
    "
    [saveText]="localizationKeys.aumico_change_password_relogin_button | i18next"
    [hideCloseIcon]="true"
    (save)="logout()"
    (cancel)="logout()"
>
    <div>
        {{
            (reloginReason === 'changed'
                ? localizationKeys.aumico_change_password_relogin_description
                : localizationKeys.aumico_change_password_relogin_failed_description
            ) | i18next
        }}
    </div>
</ham-modal>
